import React from 'react';
import Bet from '../../common/Bet';
import { BetsExpandCollapseContext } from '../../common/BetsExpandCollapseContext';
import { GroupedViewBet } from '../../common/GroupedView';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { labels } from '../../data/labels';
import { LiveMatchContext } from './LiveMatchDataFetcher';

export default function LiveMatch(props) {
    const liveMatchContext = React.useContext(LiveMatchContext);
    const betsExpandCollapseContext = React.useContext(BetsExpandCollapseContext);
    
    let betsList = props.bets;
    betsList = betsList.filter(b => {
        b.odds = b.odds.filter(o => o.value != null);
        if (!b.odds.length > 0) {
            return false;
        } else if (liveMatchContext.favoritesSelected) {
            return liveMatchContext.isMarketFavorite(props.sportRef, `${b.id}_${b.handicap}`);
        }
        return true;
    });
    // betsList = filtraParametriche(betsList);

    return (
        <div className="overlay-container">
            <ul id="oddslist">
                {liveMatchContext.favoritesSelected && betsList.length === 0 ?
                    <div className="text-center">{labels['favorite_markets.add_markets']}</div>
                    :
                    <>
                        {betsList.map((b, i) => {
                            const toggleCollapseId = `${props.uniqueId}-${props.aggregata}-${b.id}-${i}`;
                            function isExpanded(id) {
                                return !betsExpandCollapseContext.isBetCollapsed(id);
                            }
                            const expanded = isExpanded(toggleCollapseId);

                            {/* if (b.parametrica) {
                                return (
                                    <BetWrapper key={b.uniqueId}
                                                desc={b.desc}
                                                bets={props.betsById.get(b.id)}
                                                toggleCollapseId={toggleCollapseId}
                                                expanded={expanded}
                                    />
                                );
                            } */}

                            let groupedView = false;
                            if (GROUPED_VIEW_MARKETS.includes(b.cs)) {
                                groupedView = true;
                            }

                            if (groupedView) {
                                return <GroupedViewBet toggleCollapseId={toggleCollapseId} expanded={expanded} match={props} bet={b} />;
                            }

                            return <Bet key={b.uniqueId} toggleCollapseId={toggleCollapseId} {...b} expanded={expanded} />
                        })}
                    </>
                }
            </ul>
        </div>
    );
}
